import {
    AsyncTypeahead,
    Typeahead,
    Menu,
    MenuItem
} from 'react-bootstrap-typeahead';
import { Controller, Control } from 'react-hook-form';
import 'react-bootstrap-typeahead/css/Typeahead.css';
// import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';

type HyperTypeaheadProps = {
    name: string;
    options: any[];
    multiple?: boolean;
    placeholder?: string;
    labelKey?: string | ((option: any) => string);
    validation?: Record<string, any>;
    control?: Control<any>;
    isInvalid?: boolean;
    disabled?: boolean;
    aSync?: boolean;
    isLoading?: boolean;
    onChange?: Function;
    onSearch?: (query: string) => void;
};

const HyperTypeahead = ({
    name,
    control,
    options,
    multiple,
    placeholder,
    validation,
    labelKey = 'name',
    isInvalid,
    disabled,
    aSync,
    isLoading,
    onChange,
    onSearch
}: HyperTypeaheadProps) => {
    const filterProp = multiple ? {} : { filterBy: () => true };
    return (
        <Controller
            control={control}
            name={name}
            rules={validation}
            render={({ field: { onChange: onControllerChange, value } }) =>
                aSync ? (
                    <AsyncTypeahead
                        id={`async-typeahead-${name}`}
                        labelKey={labelKey}
                        multiple={multiple}
                        options={options}
                        placeholder={placeholder ? placeholder : 'Select...'}
                        selected={value ? value : []}
                        onChange={onControllerChange}
                        isInvalid={isInvalid}
                        clearButton={true}
                        disabled={disabled}
                        isLoading={isLoading}
                        onSearch={onSearch}
                        renderMenu={(results, menuProps) => (
                            <Menu
                                {...menuProps}
                                style={{
                                    width: 'max-content',
                                    minWidth: '100%'
                                }}
                            >
                                {results.map((option, position) => (
                                    <MenuItem
                                        option={option}
                                        position={position}
                                        key={position}
                                    >
                                        {typeof labelKey === 'string'
                                            ? option[labelKey]
                                            : labelKey(option)}
                                    </MenuItem>
                                ))}
                            </Menu>
                        )}
                    />
                ) : (
                    <Typeahead
                        id={`typeahead-${name}`}
                        labelKey={labelKey}
                        multiple={multiple}
                        options={options}
                        placeholder={placeholder ? placeholder : 'Select...'}
                        selected={value ? value : []}
                        onChange={(e) => {
                            onControllerChange(e);
                            onChange && onChange(e); 
                        }}
                        isInvalid={isInvalid}
                        clearButton={true}
                        disabled={disabled}
                        maxResults={Number.MAX_SAFE_INTEGER}
                        renderMenu={(results, menuProps) => (
                            <Menu
                                {...menuProps}
                                style={{
                                    width: 'max-content',
                                    minWidth: '100%'
                                }}
                            >
                                {results.map((option, position) => (
                                    <MenuItem
                                        option={option}
                                        position={position}
                                        key={position}
                                    >
                                        {typeof labelKey === 'string'
                                            ? option[labelKey]
                                            : labelKey(option)}
                                    </MenuItem>
                                ))}
                            </Menu>
                        )}
                        {...filterProp}
                    />
                )
            }
        />
    );
};

export default HyperTypeahead;
